import { Button } from '@/shared/components/ui/button'
import { LexicalEditor } from 'lexical'
import { LucideIcon } from 'lucide-react'
import React from 'react'
import { Position } from '@features/screenplay/components/type'

import { Tooltip, TooltipContent, TooltipTrigger } from '@/shared/components/ui/tooltip'

interface ToolbarAction {
    label: string
    icon: LucideIcon
    onClick: (editor: LexicalEditor) => void
    iconColor?: string
}
interface NodeToolbarProps {
    coords: Position | undefined
    editor: LexicalEditor
    toolbarActions: ToolbarAction[]
    ref: React.RefObject<HTMLDivElement | null>
}

export const NodeToolbar = ({ coords, toolbarActions, editor, ref }: NodeToolbarProps) => {
    return (
        <>
            <div
                ref={ref}
                style={{
                    position: 'absolute',
                    top: coords?.top,
                    left: coords?.left,
                    visibility: coords ? 'visible' : 'hidden',
                    opacity: coords ? 1 : 0,
                }}
                className=""
            >
                <div className="inline-flex items-center gap-1 bg-slate-100 px-2 py-1 rounded-xl shadow-sm border border-slate-200">
                    {toolbarActions.map(({ label, icon: Icon, onClick, iconColor }, index) => (
                        <Tooltip>
                            <TooltipTrigger asChild>
                                <Button
                                    key={index}
                                    variant={'ghost'}
                                    size={'icon'}
                                    className="w-7 h-7"
                                    aria-label={label}
                                    onClick={() => {
                                        onClick(editor)
                                    }}
                                >
                                    <Icon className={`w-4 h-4 ${iconColor || 'text-slate-600'}`} />
                                </Button>
                            </TooltipTrigger>
                            <TooltipContent>
                                <p>{label}</p>
                            </TooltipContent>
                        </Tooltip>
                    ))}
                </div>
            </div>
        </>
    )
}

export default NodeToolbar
